import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContextProvider from "../hooks/useAuthContext";

import { Private } from "./Private";

import Error404 from "../pages/Alerts/Error";

import Login from "../pages/User/Login/Login";
import Cadastro from "../pages/User/Cadastro/Cadastro";
import Obrigado from "../pages/Alerts/Obrigado/Obrigado";
import Profile from "../pages/Profile/Profile";
import AbrirChamado from "../pages/AbrirChamado/AbrirChamado";
import Duvidas from "../pages/Duvidas/Duvidas";
import AtualizarDados from "../pages/User/AtualizarDados/AtualizarDados";
import Admin from "../pages/Admin/Admin";
import CadastroInfluenciador from "../pages/User/CadastroInfluenciador/CadastroInfluenciador";
import Cortador from "../pages/Contratos/Cortador";
import RecuperarSenha from "../pages/User/RecuperarSenha/RecuperarSenha";
import NovaSenha from "../pages/User/RecuperarSenha/NovaSenha";
import Influenciador from "../pages/Contratos/Influenciador";
import EmitirNotaFiscal from "../pages/NotaFiscal/EmitirNotaFiscal";
import MinhasNotasFiscais from "../pages/NotaFiscal/MinhasNotasFiscais";
import Descontos from "../pages/Admin/Descontos/Descontos";
import NotasFiscais from "../pages/Admin/NotasFiscais/NotasFiscais";
import Logs from "../pages/Admin/Logs/Logs";
import Dolar from "../pages/Admin/Dolar/Dolar";
import ReceitasUsuarios from "../pages/ReceitasUsuarios/ReceitasUsuarios";
import AfiliadoDashboard from "../pages/Profile/components/AfiliadoDashboard/AfiliadoDashboard";
import Header from "../components/Header/Header";

const AppRoutes = () => {
  return (
    <BrowserRouter basename="/">
      <ContextProvider>
        <ToastContainer position="top-right" closeOnClick outClose={3000} />

        <Routes>
          <Route
            exact
            path="/"
            element={
              <Private role={["usuario", "influenciador", "afiliado"]}>
                <Profile />
              </Private>
            }
          />
          <Route exact path="/abrir-chamado" element={<AbrirChamado />} />
          <Route
            exact
            path="/duvidas"
            element={
              <Private role={["usuario", "influenciador", "afiliado"]}>
                <Duvidas />
              </Private>
            }
          />
          <Route
            exact
            path="/atualizar-dados"
            element={
              <Private role={["usuario", "influenciador", "afiliado"]}>
                <AtualizarDados />
              </Private>
            }
          />

          <Route
            exact
            path="/emitir-nota-fiscal"
            element={
              <Private role={["usuario", "influenciador", "afiliado"]}>
                <EmitirNotaFiscal />
              </Private>
            }
          />

          <Route
            exact
            path="/minhas-notas-fiscais"
            element={
              <Private role={["usuario", "influenciador", "afiliado"]}>
                <MinhasNotasFiscais />
              </Private>
            }
          />

          <Route
            path="/obrigado"
            element={
              <Private role={["usuario", "influenciador", "afiliado"]}>
                <Obrigado />
              </Private>
            }
          />

          <Route
            path="/receitas-usuarios"
            element={
              <Private role={["usuario", "influenciador", "afiliado"]}>
                <ReceitasUsuarios />
              </Private>
            }
          />

          <Route
            path="/admin"
            element={
              <Private role={["administrador", "automacao", "gestor"]}>
                <Admin />
              </Private>
            }
          />

          <Route
            path="/admin/descontos"
            element={
              <Private
                role={["administrador", "automacao", "gestor", "financeiro"]}
              >
                <Descontos />
              </Private>
            }
          />

          <Route
            path="/admin/notas-fiscais"
            element={
              <Private
                role={["administrador", "automacao", "gestor", "financeiro"]}
              >
                <NotasFiscais />
              </Private>
            }
          />

          <Route
            path="/admin/logs"
            element={
              <Private role={["administrador"]}>
                <Logs />
              </Private>
            }
          />

          <Route
            path="/admin/dolar"
            element={
              <Private role={["administrador", "financeiro"]}>
                <Dolar />
              </Private>
            }
          />

          <Route
            path="/meu-afiliado"
            element={
              <Private role={["usuario", "influenciador", "afiliado"]}>
                <Header urlFoto="https://i.imgur.com/nCIToeZ.png" />
                <div className="content">
                  <div className="wrapper">
                    <AfiliadoDashboard />
                  </div>
                </div>
              </Private>
            }
          />

          <Route path="/recuperar-senha" element={<RecuperarSenha />} />
          <Route path="/recuperar-senha/:code" element={<NovaSenha />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Cadastro />} />
          <Route
            path="/cadastro-influenciador"
            element={<CadastroInfluenciador />}
            Y
          />

          <Route path="/contrato-cortador" element={<Cortador />} />
          <Route path="/contrato-influenciador" element={<Influenciador />} />

          <Route path="*" element={<Error404 />} />
        </Routes>
      </ContextProvider>
    </BrowserRouter>
  );
};

export default AppRoutes;
